<template>
    <div ref="accountCreatedRef" class="account-created-container">
        <div class="login-header">
            <div><img class="medium-logo" src="../assets/DineSafeSquare.png"/></div>
            <div class="title dinesafe-purple">DineSafeVT</div>
            <div class="dinesafe-label">Welcome!</div>
        </div>

        <div class="account-created">Your account has been created.</div>
        <div class="account-created">A confirmation message has been e-mailed to you.</div>
       
        <div class="account-created-buttons">
            <div class="center-button">
                <DxButton
                    ref="btnLoginRef"              
                    type="default" 
                    width="100%"
                    height="100%"                 
                    text="Login"
                    @click="onLoginClick"
                />
            </div>

            <!--<div class="center-button">
                <DxButton
                    ref="btnScanQR"      
                    type="normal"          
                    width="180"
                    height="100%"           
                    text="Scan QR Code"
                    @click="onScanQRClick"
                />
            </div>-->            
        </div>
    </div>
</template>

<script>
    import {DxButton} from 'devextreme-vue';

    export default {
        components: {
            DxButton,
        },
        props: {
            email: String,
        },
        data(){
            return{
                someVar: true,
            }
        },
        methods:{
            /*
                Navigate to the login page.
            */
            onLoginClick() {
                this.$router.push({
                path: "/login-form",
                query: { redirect: this.$route.path }
                });
            },
        }
    }
</script>

<style>
  @import '../themes/contact-tracing.css';
  
  .account-created{
    padding-top:10px;
    max-width: 200px;
    margin: auto;
  }

  .account-created-link{
      margin: auto;
  }

  .account-created-buttons{
    margin:auto;
    padding: 20px;
    width: 200px;
  }

</style>
